import React, { useEffect, useState } from 'react';

import { Button, Collapse, Empty, Layout, Menu, Modal } from 'antd';
import { capitalizeFirstLetterOnly } from '@/helpers/dataHelper';
import router from 'next/router';
import { addData } from '@/actions/auth';
import { useDispatch } from 'react-redux';

const Curriculum = ({
  courseEnroll,
  course,
  clickPreview,
  getVideo,
  cRef,
  isMobile,
  ModalLoginOpen,
  auth,
  addEnroll,
}) => {
  const { Sider, Content } = Layout;
  const { Panel } = Collapse;
  const dispatch = useDispatch();
  const [activeSubject, setActiveSubject] = useState<any>();
  const [enrolModal, setEnrolModal] = useState<boolean>(false);

  useEffect(() => {
    return () => {
      dispatch(
        addData({
          key: 'isCurriculumRedirect',
          value: false,
        })
      );
      dispatch(
        addData({
          key: 'courseData',
          value: {},
        })
      );
    };
  }, []);

  useEffect(() => {
    if (course?.subject?.length) {
      setActiveSubject(course?.subject[0]);
    }
  }, [course]);

  return (
    <>
      <h4 className="text-black pb-2  mt-4">Course Curriculum</h4>
      <Modal
        centered
        visible={enrolModal}
        onCancel={() => setEnrolModal(false)}
        maskClosable={false}
        footer={[]}
      >
        <div className="text-center mx-3">
          <img
            alt="course-preview"
            src={
              course?.ad_video?.poster
                ? course?.ad_video?.poster
                : course?.image
                ? course?.image
                : '/images/course.webp'
            }
            style={{ height: '225px', width: '500px' }}
          />
          <Button
            className="btn-secondary border-18 border-danger mt-3"
            onClick={() => addEnroll()}
          >
            Enroll to Course to View Content
          </Button>
        </div>
      </Modal>

      <Layout
        className={`curriculum-page ${isMobile ? 'rounded px-1' : ''}`}
        style={{ height: 'auto' }}
      >
        {isMobile ? (
          <Menu
            className="pb-2 rounded curriculum-menu"
            mode={isMobile ? 'horizontal' : 'vertical'}
            defaultActiveFirst
            style={{
              overflowX: isMobile ? 'auto' : 'initial',
              display: 'flex',
              // width: '100%',
            }}
            disabledOverflow
          >
            {course?.subject?.length !== 0 &&
              course?.subject?.map((data, keySubject) => (
                <Menu.Item
                  className={`pr-1 p-2`}
                  onClick={() => setActiveSubject(data)}
                  key={keySubject}
                >
                  <div
                    className={`px-2 mb-0 rounded font-weight-500 border ${
                      activeSubject?.id === data?.id ? 'active-subject' : ''
                    }`}
                  >
                    {capitalizeFirstLetterOnly(data.name)}
                    {/* </div> */}
                  </div>
                </Menu.Item>
              ))}
          </Menu>
        ) : (
          <Sider>
            <div
              className="py-2 border"
              style={{
                boxShadow: 'rgba(0, 0, 0, 0.09) 0px 3px 12px',
                borderRadius: '5px',
              }}
            >
              {course?.subject?.length !== 0 &&
                course?.subject?.map((data, keySubject) => (
                  <div
                    className="px-2 mb-0 font-size-sm pb-1 font-weight-500"
                    key={keySubject}
                  >
                    <div
                      className={`course-button montserrat-font-family w-100 px-2 py-1 cursor-pointer font-sm ${
                        activeSubject?.id === data?.id ? 'btn-primary' : ''
                      }`}
                      onClick={() => setActiveSubject(data)}
                      style={{ lineHeight: '1.8rem' }}
                    >
                      {capitalizeFirstLetterOnly(data.name)}
                    </div>
                  </div>
                ))}
            </div>
          </Sider>
        )}
        <Content
          className={`${isMobile ? 'ml-0' : 'ml-3'}`}
          style={{ background: 'transparent' }}
        >
          {activeSubject && activeSubject?.chapter?.length !== 0 ? (
            activeSubject?.chapter?.map((dataChapter, keyChapter) => {
              return (
                <Collapse
                  accordion
                  defaultActiveKey={['0']}
                  key={keyChapter}
                  expandIconPosition="end"
                  style={{
                    boxShadow: isMobile ? 'none' : 'rgb(0 0 0 / 16%) 0px 1px 4px',
                    borderRadius: '5px',
                  }}
                  ghost={isMobile ? true : false}
                >
                  <Panel
                    header={
                      <div style={{ lineHeight: '1.8rem' }}>
                        <strong>
                          {keyChapter + 1}. {dataChapter?.name}{' '}
                        </strong>
                        <span className="lectures float-right ml-auto">
                          ({dataChapter?.no_contents} lectures -{' '}
                          {dataChapter?.chapter_length})
                        </span>
                      </div>
                    }
                    key={keyChapter}
                    className="mb-2"
                  >
                    <ul className="list-unstyled">
                      {dataChapter?.content?.map((dataContent, keyContent) => (
                        <li
                          key={keyContent}
                          className="pt-2 cursor-pointer curriculum-li-content"
                        >
                          <div className="item-link-content-title d-flex">
                            {dataContent?.content_type == 0 ? (
                              <img
                                src="/images/svgs/video.svg"
                                className="mr-3"
                                width={36}
                              />
                            ) : (
                              <img
                                src="/images/svgs/quiz.svg"
                                className="mr-3"
                                width={36}
                              />
                            )}

                            <div className="d-flex flex-column">
                              {!auth ? (
                                // user not logged in
                                <span
                                  className={`text-decoration-underline`}
                                  onClick={() => {
                                    dispatch(
                                      addData({
                                        key: 'isCurriculumRedirect',
                                        value: true,
                                      })
                                    );
                                    dispatch(
                                      addData({
                                        key: 'courseData',
                                        value: {
                                          courseSlug: course?.slug,
                                          subjectId: activeSubject?.id,
                                          chapterId: dataChapter?.id,
                                          contentId: dataContent?.id,
                                        },
                                      })
                                    );
                                    ModalLoginOpen();
                                  }}
                                >
                                  {dataContent?.name}
                                </span>
                              ) : courseEnroll?.is_enroll ? (
                                // logged in and enrolled user
                                <span
                                  className={`text-decoration-underline`}
                                  onClick={() =>
                                    router.push({
                                      pathname: `/course/lesson/${course?.slug}/`,
                                      query: {
                                        subtab: activeSubject?.id,
                                        chaptab: dataChapter?.id,
                                        activetab: dataContent?.id,
                                      },
                                    })
                                  }
                                >
                                  {dataContent?.name}
                                </span>
                              ) : course?.is_free ? (
                                // logged in, not enrolled free course
                                <span
                                  // className={`content-title ml-2`}
                                  // onClick={() =>
                                  //   router.push({
                                  //     pathname: `/course/lesson/preview/${course.slug}`,
                                  //     query: {
                                  //       subtab: data?.id,
                                  //       chaptab: dataChapter?.id,
                                  //       activetab: dataContent?.id,
                                  //     },
                                  //   })
                                  // }
                                  onClick={() => setEnrolModal(true)}
                                >
                                  {dataContent?.name}
                                </span>
                              ) : (
                                // logged in, not enrolled, paid course
                                <span
                                  className={`text-decoration-underline`}
                                  // className={`content-title ml-2 clickable`}
                                  onClick={() =>
                                    router.push({
                                      pathname: `/course/lesson/preview/${course?.slug}`,
                                      query: {
                                        subtab: activeSubject?.id,
                                        chaptab: dataChapter?.id,
                                        activetab: dataContent?.id,
                                      },
                                    })
                                  }
                                >
                                  {dataContent?.name}
                                </span>
                              )}

                              {dataContent?.content_type == 0 ? (
                                <small className="item-link-duration">
                                  Lesson | {dataContent?.length}
                                </small>
                              ) : (
                                <small className="item-link-duration">Quiz</small>
                              )}
                            </div>
                            {!dataContent?.preview &&
                              courseEnroll &&
                              !courseEnroll?.is_enroll && (
                                <div className="ml-auto">
                                  <i className="fas fa-lock mr-2"></i>
                                </div>
                              )}
                          </div>
                          {keyContent !== dataChapter?.content?.length - 1 &&
                          !isMobile ? (
                            <hr />
                          ) : (
                            ''
                          )}
                        </li>
                      ))}
                    </ul>
                  </Panel>
                </Collapse>
              );
            })
          ) : (
            <Empty />
          )}
        </Content>
      </Layout>
    </>
  );
};

export default Curriculum;
